// createParticlesMaterial.jsx
import { shaderMaterial } from '@react-three/drei'
import { Vector2 } from 'three'
import vertexShader from '../shaders/particles/vertex.glsl'
import fragmentShader from '../shaders/particles/fragment.glsl'

const ParticlesShaderMaterial = shaderMaterial(
    {
        uSize: 0.1,
        uResolution: new Vector2(window.innerWidth, window.innerHeight),
        uParticlesTexture: null,
        uProgress: 0,
    },
    vertexShader,
    fragmentShader
)

export default function createParticlesMaterial(size, pixelRatio) {
    // Update the resolution based on current canvas size
    const material = new ParticlesShaderMaterial()
    material.uniforms.uResolution.value.set(
        size.width * pixelRatio,
        size.height * pixelRatio
    )
    return material
}
